
























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ManageCandidates extends Vue {
    private candidates: { ID: string; Name: string }[] = [];

    private nameToAdd = '';

    private alertText = '';

    private get canSubmit(): boolean {
        return true; // this.nameToAdd != '';
    }

    mounted() {
        this.updateCandidates();
    }

    async updateCandidates() {
        try {
            const response = await this.$http.get(
                '/election/candidate'
            );
            this.candidates = response.data;
        } catch (err) {
            this.alertText = err.response.data;
        }
    }

    async addCandidate() {
        this.alertText = '';
        try {
            await this.$http.post(
                '/election/candidate',
                { 
                    name: this.nameToAdd
                }
            );
            this.nameToAdd = '';

            this.updateCandidates();
            
        } catch (err) {
            this.alertText = err.response.data;
        }
    }

    onDroppedCheckbox(event, candidate) {
        candidate.Dropped = !event.target.checked;
        this.$http.put(
            '/election/candidate/' + candidate.ID,
            {
                Dropped: candidate.Dropped
            }).then(response => {
                console.log(response.status, response.statusText);
            }).catch(err => {
                console.log("Error setting dropped", err);
            });
    }
}

